import { render, staticRenderFns } from "./RsaGestioneOspitiArchivioList.vue?vue&type=template&id=b123127c"
import script from "./RsaGestioneOspitiArchivioList.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitiArchivioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports